import Translations from 'src/core/utils/Translations';
import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import ReservationsScreenType from 'src/domain/models/ReservationsScreenType';
import AccountButton from 'src/presentation/components/molecules/AccountButton';
import { useHeaderStyle } from 'src/presentation/hooks/useHeaderStyle';
import { useActiveLanguage } from 'src/presentation/hooks/useActiveLanguage';
import { headerBackButton, nestedStackScreenOptions } from 'src/presentation/navigation/defaultScreenOptions';
import type { BookingNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import ReservationDetailScreen from 'src/presentation/screens/ReservationDetailScreen';
import ReservationsScreen from 'src/presentation/screens/ReservationsScreen';
import ReserveScreen from 'src/presentation/screens/ReserveScreen';

const Stack = createStackNavigator<BookingNavigation>();

export default function BookingStackNavigator() {
	useActiveLanguage();

	const headerStyle = useHeaderStyle();

	const detailScreenOptions =
		({ title }: { title: string }) =>
		({ navigation: screenNavigation }: { navigation: { goBack: () => void } }) => ({
			title,
			headerStyle,
			headerLeft: () => headerBackButton({ navigation: screenNavigation }),
		});

	return (
		<Stack.Navigator screenOptions={nestedStackScreenOptions}>
			<Stack.Screen
				component={ReserveScreen}
				name={Constants.screenReserve}
				options={{
					headerStyle,
					headerTitle: Translations.tabsBooking,
					headerRight: () => <AccountButton style={{ marginHorizontal: Dimens.padding18 }} />,
				}}
			/>
			<Stack.Screen
				component={ReservationsScreen}
				initialParams={{ screenType: ReservationsScreenType.upcoming }}
				name={Constants.screenUpcomingReservations}
				options={detailScreenOptions({ title: Translations.accountUpcomingReservations })}
			/>
			<Stack.Screen
				component={ReservationsScreen}
				initialParams={{ screenType: ReservationsScreenType.historical }}
				name={Constants.screenPastReservations}
				options={detailScreenOptions({ title: Translations.accountPastReservations })}
			/>
			<Stack.Screen
				component={ReservationDetailScreen}
				name={Constants.screenReservationDetail}
				options={detailScreenOptions({ title: Translations.reservationYourReservation })}
			/>
		</Stack.Navigator>
	);
}
